import React, { Component } from "react"
import { Tag, Input } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { fetchAllFolderTags, fetchAllPatientFolders } from "redux_actions/patientfolder.state.action"
import { error_manager } from "helper/error_manager"
import { connect } from "react-redux"
import { post } from "helper/request"

class NewFolderTag extends Component {
    constructor(props) {
        super(props)

        this.state = {
            editMode: false,
            isLoading: false,
            tagName: "",
        }

    }

    handleClick = (e) => {
        e?.stopPropagation()
        this.setState({ editMode: true })
    }

    handlePressEnter = async () => {
        const value = this.state.tagName
        if (value.trim().length < 1) return

        this.setState({
            isLoading: true,
        })

        try {
            const tagAlreadyExists = this.props.allTags.includes(value)
            if (!tagAlreadyExists) {
                await this.createNewTag(value)
                fetchAllFolderTags()
            }
            await this.addTagIntoFolder(value)
            fetchAllPatientFolders()

            this.setState({
                editMode: false,
            })
        } catch (err) {
            error_manager(`Unable to create new tag ${value}`)
            console.error(err.message)
        } finally {
            this.setState({
                isLoading: false,
            })
        }
    }

    createNewTag = (name) => post("/api/patient_folder_tag/", { name })
    
    addTagIntoFolder = (tag) => post("/api/update_tags_in_folder/", { action: "add", tags: [tag], folder_id: this.props.folderId})

    render() {
        return !this.state.editMode ?
            <Tag onClick={this.handleClick} style={{ cursor: "pointer" }}>
                <span>Add Tag</span>
                <PlusOutlined />
            </Tag>
            :
            <span onClick={e => e?.stopPropagation()}>
                <Input
                    disabled={this.state.isLoading}
                    value={this.state.tagName}
                    onChange={(e) => this.setState({ tagName: e?.target?.value })}
                    onPressEnter={this.handlePressEnter}
                />
            </span>
    }
}

const mapStateToProps = (state) => ({
    allTags: state.patientfolderReducer.allTags,
})

export default connect(mapStateToProps)(NewFolderTag)